export default "__VITE_ASSET__BvFZcm4Q__"